<template>
  <div class="container mt-4" v-if="holidayItems && holidayItems.length">
    <b-row align-h="center">
      <b-col :cols="12" :lg="9">
        <h5 class="text-uppercase title-slash heading-desc mb-4">
          {{ title }}
        </h5>
        <h6 class="text-uppercase heading-caption">{{ subtext }}</h6>
      </b-col>
    </b-row>
    <b-row align-h="center" class="items-style font-weight-bold">
      <b-col
        :cols="4"
        :lg="3"
        class="mt-5 mb-3 fields text-uppercase"
        v-for="item in fields"
        :key="item.id"
      >
        {{ item }}
      </b-col>
    </b-row>
    <b-row
      class="items-style font-weight-bold py-3"
      align-h="center"
      v-for="item in holidayItems"
      :key="item.id"
    >
      <b-col :cols="4" :lg="3" class="holiday-cell">{{ item.holiday }}</b-col>
      <b-col :cols="4" :lg="3">{{ getDayByDate(item.date) }}</b-col>
      <b-col :cols="4" :lg="3">{{ item.date }}</b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['title', 'subtext', 'fields', 'holidayItems'],
  methods: {
    getDayByDate(date) {
      return moment(date, 'MMMM D, YYYY').format('dddd').toString()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card-body {
  padding-bottom: 0 !important;
  font-family: $nunito;
}
.items-style {
  font-size: 14px;
  border-bottom: 1px solid $dc-form-border-color;
}
.fields {
  font-size: 16px;
}
.title-slash::after {
  left: 0;
}
.holiday-cell {
  color: $primary;
}
.heading-desc {
  font-size: 20px;
  font-weight: 600;
}
.heading-caption {
  font-size: 12px;
}
</style>
